import getScrollAccessor from './getScrollAccessor';
export default getScrollAccessor('pageXOffset');


//////////////////
// WEBPACK FOOTER
// ../~/dom-helpers/esm/scrollLeft.js
// module id = 653
// module chunks = 121